import { Snackbar, Alert } from '@mui/material'
import React from 'react'
import { SnackbarActionType } from '../constants';
import { useSnackbarData, useSnackbarDispatch } from '../SnackbarDataStore/Context'
import { useStateContext } from '../Store/Context';
import { ISnackbarAction } from '../types';

const GlobalSnackbar = () => {

	const snackbarData = useSnackbarData();
	const snackDispatch = useSnackbarDispatch();
	const {medium} = useStateContext();

	const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
		if (reason === 'clickaway') {
		  return;
		}
	
		const action: ISnackbarAction = {
			type: SnackbarActionType.UNSET_SNACK,
			payload: {
				message: "",
				severity: 'success'
			}
		}

		snackDispatch(action);

	  };

	return (
		<div style={medium==='extension'?{willChange: "transform"}:{}}>
			<Snackbar
				open={snackbarData.open}
				autoHideDuration={5000}
				onClose={handleClose}
			>
				<Alert onClose={handleClose} severity={snackbarData.severity}>{snackbarData.message}</Alert>
			</Snackbar>
		</div>
	)
}

export default GlobalSnackbar